import { render, staticRenderFns } from "./EditSnapshotSidebar.vue?vue&type=template&id=5a79ae2a&scoped=true"
import script from "./EditSnapshotSidebar.vue?vue&type=script&lang=js"
export * from "./EditSnapshotSidebar.vue?vue&type=script&lang=js"
import style0 from "./EditSnapshotSidebar.vue?vue&type=style&index=0&id=5a79ae2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79ae2a",
  null
  
)

export default component.exports